import { createFilterOptions } from '@material-ui/lab';
import React from 'react';
import AfitdAutocompleteLite from './AfitdAutocompleteLite';

// import { withStyles } from '@material-ui/core/styles';
// import cx from 'clsx';
// import _map from 'lodash/map';

// const styles = theme => ({
// });

const getOptionLabel = option => {
    return typeof option === 'string' ? option : option.name;
};

const getOptionSelected = (option, value) => (typeof value === 'string' ? option.name === value : option.name === value?.name);

const AfitdCountryAutocomplete = props => {
    const filterOptions = createFilterOptions({ matchFrom: 'start' });
    return <AfitdAutocompleteLite {...props} getOptionLabel={getOptionLabel} getOptionSelected={getOptionSelected} filterOptions={filterOptions} />;
};

export default AfitdCountryAutocomplete;
// export default withStyles(styles)(AfitdCountryAutocomplete);
